import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Input, Upload, notification } from 'antd';
import AWS from 'aws-sdk';
import { GET, PUT } from '../../utils/apicalls';
import { API } from '../../config/api';




function UpdateVideoManagement() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [fileUrl, setFileUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    interface AwsData {
        accessKeyId?: string;
        secretAccessKey?: string;
        region?: string;
        [key: string]: any;
    }
    const [awsData, setawsData] = useState<AwsData>({});
    const s3 = new AWS.S3({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
    });
    const fetchawsDetails = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
            if (response && response.accessKeyId) {
                setawsData(response); // Not response.data
            } else if (response?.data?.accessKeyId) {
                setawsData(response.data); // If using Axios-style
            } else {
                console.warn("AWS credentials not found in response", response);
            }
        } catch (error) {
            console.error("Failed to fetch AWS credentials", error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
            AWS.config.update({
                accessKeyId: awsData.accessKeyId,
                secretAccessKey: awsData.secretAccessKey,
                region: awsData.region,
            });
        }
    }, [awsData]);
    useEffect(() => {
        fetchawsDetails();
    }, []); const S3_BUCKET = awsData?.bucketName;

    const fetchOneVideo = async () => {
        try {
            let api = API.GET_ONE_VIDEO_MANAGEMENT + id;
            const res: any = await GET(api, {});
            if (res.status && res.data) {
                const data = res.data;
                setFileUrl(data.videomanagementVideo);
                form.setFieldsValue({
                    videomanagementTitle: data.videomanagementTitle,
                    videomanagementDescription: data.videomanagementDescription,
                    videomanagementVideo: data.videomanagementVideo,
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchOneVideo();
    }, [id]);

    const uploadProps = {
        name: "file",
        headers: {
            "x-amz-acl": "public-read",
        },
        accept: "video/*,image/*",
        showUploadList: false,
        beforeUpload: (file: any) => {
            const isValid = file.type.startsWith("video/") || file.type.startsWith("image/");
            if (!isValid) {
                notification.error({ message: "Only video or image files are allowed!" });
            }
            return isValid || Upload.LIST_IGNORE;
        },
        customRequest: async ({ file, onSuccess, onError }: any) => {
            const fileName = `videos/${Date.now()}_${file.name}`;
            const params = {
                Bucket: S3_BUCKET,
                Key: fileName,
                Body: file,
                ContentType: file.type,
            };

            s3.upload(params, (err: any, data: any) => {
                if (err) {
                    onError(err);
                    notification.error({ message: "Upload failed!" });
                } else {
                    setFileUrl(data.Location);
                    form.setFieldsValue({ videomanagementVideo: data.Location });
                    onSuccess(data);
                    notification.success({ message: "File uploaded successfully!" });
                }
            });
        },
    };

    const submitHandler = async (values: any) => {
        try {
            const obj = {
                videomanagementTitle: values.videomanagementTitle,
                videomanagementDescription: values.videomanagementDescription,
                videomanagementVideo: fileUrl,
            };

            setIsLoading(true);
            const updateUrl = `${API.UPDATE_VIDEO_MANAGEMENT}${id}`;
            const res: any = await PUT(updateUrl, obj);

            if (res.status) {
                notification.success({ message: "Updated successfully!" });
                navigate(-1);
            } else {
                notification.error({ message: "Update failed!" });
            }
        } catch (error) {
            console.error(error);
            notification.error({ message: "Something went wrong!" });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="p-4">
            <h2>Update Video/Image</h2>
            <Form form={form} layout="vertical" onFinish={submitHandler}>
                <Form.Item
                    name="videomanagementTitle"
                    label="Title"
                    rules={[{ required: true, message: "Please enter a title" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="videomanagementDescription"
                    label="Description"
                    rules={[{ required: true, message: "Please enter a description" }]}
                >
                    <Input.TextArea />
                </Form.Item>

                <Form.Item
                    name="videomanagementVideo"
                    label="Upload Video / Image"
                    rules={[{ required: true, message: "Please upload a video or image" }]}
                >
                    <Upload {...uploadProps}>
                        <Button className="w-full">Upload Video / Image</Button>
                    </Upload>

                    {fileUrl && fileUrl.match(/\.(mp4|webm|ogg)$/i) && (
                        <video
                            src={fileUrl}
                            controls
                            className="w-full mt-2"
                            style={{ height: "300px", objectFit: "cover" }}
                        />
                    )}

                    {fileUrl && fileUrl.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) && (
                        <img
                            src={fileUrl}
                            alt="Uploaded"
                            className="w-full mt-2"
                            style={{ height: "300px", objectFit: "cover" }}
                        />
                    )}
                </Form.Item>

                <Button type="primary" htmlType="submit" loading={isLoading} block>
                    Update
                </Button>
            </Form>
        </div>
    );
}

export default UpdateVideoManagement;
